/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */

export type PatientDtoGender = (typeof PatientDtoGender)[keyof typeof PatientDtoGender];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatientDtoGender = {
  UNKNOWN: 'UNKNOWN',
  MALE: 'MALE',
  FEMALE: 'FEMALE',
  OTHER: 'OTHER',
} as const;
